import { Session } from 'next-auth'
import { BazaarvoiceReviewSortKey, ReviewData } from 'shared-types'

import { IReviewClient } from '~/types/Client'
import { request } from './request'

export class ReviewClient implements IReviewClient {
  getReviews = async (
    sku: string,
    session: Session,
    limit?: number,
    page?: number,
    sort?: BazaarvoiceReviewSortKey,
  ): Promise<ReviewData> => {
    const query: Record<string, string> = { sku }

    if (limit !== undefined) {
      query.limit = String(limit)
    }

    if (page !== undefined) {
      query.page = String(page)
    }

    if (sort !== undefined) {
      query.sort = sort
    }

    const response = await request<ReviewData>({
      url: '/bff/reviews',
      method: 'GET',
      query,
    }, session)

    if (response.getErrorSafe()) {
      return {
        reviews: [],
        total: 0,
        totalPages: 0,
        averageRating: 0,
        ratingDistribution: [],
      }
    }

    return response.getValueSafe()
  }

  submitReviewFeedback = async (
    contentId: string,
    isPositive: boolean,
    session: Session,
  ): Promise<boolean> => {
    const response = await request<{ isSuccess: boolean }>({
      url: '/bff/reviews/feedback',
      method: 'POST',
      body: {
        contentId,
        isPositive,
      },
    }, session)

    if (response.getErrorSafe()) {
      return false
    }

    return response.getValueSafe()?.isSuccess ?? false
  }
}
